let innerText = function(reactElement) {
  if (reactElement === null) return "";
  if (typeof reactElement?.$$typeof === "undefined")
    return typeof reactElement === "undefined" ? "" : reactElement.toString();
  let children = reactElement.props.children;
  // Handle the case when the element doesn't haev any children
  if (typeof children === "undefined") return " ";
  if (Array.isArray(children)) {
    let sb = children.map((i) => {
      if (typeof i === "string") return i;
      else return innerText(i);
    });
    return sb.join("");
  } else return innerText(children);
};

export default innerText;
